/*
  Zgoda na regulamin przy przycisku kasy (szuflada koszyka i strona koszyka).
  Przycisk "Przejdź do kasy" jest zawsze klikalny. Gdy pole zgody nie jest zaznaczone,
  klik jest wstrzymany i pod polem pokazuje się ostrzeżenie (czerwona ramka + komunikat).
*/
if (typeof TermsAndConditionsToggle !== 'function') {

  class TermsAndConditionsToggle extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('#AgreeToTos');

      if (this.checkbox) {
        this.checkbox.addEventListener('change', () => {
          if (this.checkbox.checked) {
            this.clearError();
          }
        });
      }
    }

    showError() {
      const box = this.querySelector('.agree-to-terms');
      const message = this.querySelector('.agree-to-terms__error');
      if (box) box.classList.add('agree-to-terms--error');
      if (message) message.hidden = false;
    }

    clearError() {
      const box = this.querySelector('.agree-to-terms');
      const message = this.querySelector('.agree-to-terms__error');
      if (box) box.classList.remove('agree-to-terms--error');
      if (message) message.hidden = true;
    }
  }

  if (typeof customElements.get('terms-checkbox') === 'undefined') {
    customElements.define('terms-checkbox', TermsAndConditionsToggle);
  }

  // Jeden nasłuch na całą stronę (stopka koszyka jest odświeżana po każdej zmianie).
  document.addEventListener('click', (event) => {
    const button = event.target.closest('#CheckOut');
    if (!button) return;

    const scope = button.closest('.cart__details') || document;
    const checkbox = scope.querySelector('#AgreeToTos');
    if (!checkbox || checkbox.checked) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const holder = checkbox.closest('terms-checkbox');
    if (holder && typeof holder.showError === 'function') {
      holder.showError();
    }
  }, true);

}
